import React from 'react';
import { Form } from 'react-bootstrap';
import { APPLICATION_METHODS } from './wizardConstants';
import { useJobWizard } from './JobWizardContext';

export default function Step4ApplicationMethod() {
  const { form, stepErrors: errors, updateForm: onChange } = useJobWizard();
  return (
    <div className="rwm-wizard-step">
      <h2 className="rwm-wizard-step__title">Application Method</h2>
      <p className="rwm-wizard-step__intro text-muted">
        Choose how candidates should apply to this role.
      </p>

      <fieldset className="mb-3">
        <legend className="visually-hidden">Application method</legend>
        {APPLICATION_METHODS.map((opt) => (
          <Form.Check
            key={opt.value}
            type="radio"
            name="application_method"
            id={`rwm-wizard-4-method-${opt.value}`}
            label={opt.label}
            value={opt.value}
            checked={form.application_method === opt.value}
            onChange={() => onChange('application_method', opt.value)}
            data-testid={`rwm-wizard-4-method-${opt.value}`}
          />
        ))}
      </fieldset>

      {form.application_method === 'external_url' ? (
        <Form.Group className="mb-0">
          <Form.Label htmlFor="rwm-wizard-4-url">Application URL</Form.Label>
          <Form.Control
            id="rwm-wizard-4-url"
            type="url"
            value={form.application_url}
            onChange={(e) => onChange('application_url', e.target.value)}
            isInvalid={Boolean(errors.application_url)}
            placeholder="https://careers.example.com/apply"
            data-testid="rwm-wizard-4-url"
          />
          <Form.Control.Feedback type="invalid">{errors.application_url}</Form.Control.Feedback>
        </Form.Group>
      ) : null}

      {form.application_method === 'email' ? (
        <Form.Group className="mb-0">
          <Form.Label htmlFor="rwm-wizard-4-email">Application email</Form.Label>
          <Form.Control
            id="rwm-wizard-4-email"
            type="email"
            value={form.application_email}
            onChange={(e) => onChange('application_email', e.target.value)}
            isInvalid={Boolean(errors.application_email)}
            placeholder="jobs@example.com"
            data-testid="rwm-wizard-4-email"
          />
          <Form.Control.Feedback type="invalid">{errors.application_email}</Form.Control.Feedback>
        </Form.Group>
      ) : null}

      {form.application_method === 'rwm_flow' ? (
        <p className="text-muted small mb-0" data-testid="rwm-wizard-4-rwm-hint">
          Candidates apply through RemoteWorkMarket with their profile and resume.
        </p>
      ) : null}
    </div>
  );
}
